import * as yup from "yup";

const UpdateUserInfoValidation = yup.object().shape({
	firstname: yup
		.string()
		.required("Lütfen adınızı giriniz.")
		.test(
			"firstnameLength",
			"Lütfen adınızı giriniz.",
			(val) => val?.trim().length !== undefined && val?.trim().length > 0
		)
		.nullable(),
	lastname: yup
		.string()
		.required("Lütfen soyadınızı giriniz.")
		.test(
			"lastnameLength",
			"Lütfen soyadınızı giriniz.",
			(val) => val?.trim().length !== undefined && val?.trim().length > 0
		)
		.nullable(),
	job: yup.string().required("Lütfen mesleğinizi seçiniz.").nullable(),
	title: yup.string().nullable(),
	phone: yup
		.string()
		.required("Lütfen telefon numarınızı giriniz.")
		.test(
			"phoneNumberLength",
			"Telefon numarasınızı giriniz.",
			(val) => !val?.includes("_") && val?.length === 16
		)
		.nullable(),
	gsm: yup.string().nullable(),
	companyType: yup
		.string()
		.required("Lütfen kuruluşunuzun türünüzü seçiniz.")
		.nullable(),
	companyName: yup
		.string()
		.required("Lütfen kuruluşunuzun adını giriniz.")
		.test(
			"companyNameLength",
			"Lütfen kuruluşunuzun adını giriniz.",
			(val) => val?.trim().length !== undefined && val?.trim().length > 0
		)
		.nullable(),
	province: yup.string().required("Lütfen ilinizi seçiniz.").nullable(),
	district: yup.string().nullable(),
	address: yup
		.string()
		.required("Lütfen adresinizi giriniz.")
		.test(
			"addressLength",
			"Lütfen adresinizi giriniz.",
			(val) => val?.trim().length !== undefined && val?.trim().length > 0
		)
		.nullable(),
	alternateMail: yup
		.string()
		.max(50, "İletişim e-posta adresiniz 50 karakterden uzun olamaz.")
		.email("Lütfen iletişim için geçerli olacak e-posta adresinizi giriniz.")
		.required(
			"Lütfen iletişim için geçerli olacak e-posta adresinizi giriniz."
		),
});

export default UpdateUserInfoValidation;
